import { render, staticRenderFns } from "./profileForm.vue?vue&type=template&id=1702b1f9&scoped=true"
import script from "./profileForm.vue?vue&type=script&lang=js"
export * from "./profileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1702b1f9",
  null
  
)

export default component.exports